import React, { Fragment } from 'react';
import { IoMdCreate } from 'react-icons/io';

import BankDetailsModal from './BankDetailsModal';
import { useToggle, useLockBodyScroll } from 'react-use';

const BankDetails = ({
  bankDetails,
  placeHolder,
  updateProfile,
  setProfile,
  setSession,
  setUnexpectedError
}) => {
  const { accountName, accountNumber, name, swiftCode, iBan, address } = bankDetails || {};

  const [modal, setModal] = useToggle(false);
  useLockBodyScroll(modal);

  const toggleModal = () => {
    setModal(!modal);
  };

  return (
    <Fragment>
      <div className="mt-10">
        <div className=" md:mb-10 lg:mb-6">
          <h4 className="font-bold text-xl">Bank Details</h4>
          <p>Manage and update your Bank information</p>
        </div>

        <div className="relative bg-white w-full px-4 py-4 rounded">
          <button
            className="absolute right-0 top-0 pr-6 pt-6 text-cf-300 focus:outline-none"
            onClick={toggleModal}
          >
            <IoMdCreate size={20} />
          </button>

          <form className="flex flex-wrap mt-10" action="#">
            <div className="w-full lg:w-1/2 mb-2 lg:pr-2">
              <label className="pl-2 text-sm">Account Name</label>
              <div className="bg-cf-100 py-2">
                <p className="px-4 py-2">{accountName || placeHolder('Account Name')}</p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 mb-2 lg:pl-2">
              <label className="pl-2 text-sm">Account Number</label>
              <div className="bg-cf-100 py-2">
                <p className="px-4 py-2">{accountNumber || placeHolder('Account Number')}</p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 mb-2 lg:pr-2">
              <label className="pl-2 text-sm">Bank Name</label>
              <div className="bg-cf-100 py-2">
                <p className="px-4 py-2">{name || placeHolder('Bank Name')}</p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 mb-2 lg:pl-2">
              <label className="pl-2 text-sm">Swift Code</label>
              <div className="bg-cf-100 py-2">
                <p className="px-4 py-2">{swiftCode || placeHolder('Swift Code')}</p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 mb-2 lg:pr-2">
              <label className="pl-2 text-sm">IBAN</label>
              <div className="bg-cf-100 py-2">
                <p className="px-4 py-2">{iBan || placeHolder('IBAN')}</p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 lg:pl-2 mb-2">
              <label className="pl-2 text-sm">Street</label>
              <div className="bg-cf-100 py-2">
                <p className="px-4 py-2">{(address && address.street) || placeHolder('Street')}</p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 lg:pr-2 mb-2">
              <label className="pl-2 text-sm">State/Region/City</label>
              <div className="bg-cf-100 py-2">
                <p className="px-4 py-2">
                  {(address && address.state) || placeHolder('State/Region/City')}
                </p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 lg:pl-2 mb-2">
              <label className="pl-2 text-sm">Country</label>
              <div className="bg-cf-100 py-2">
                <p className="px-4 py-2">
                  {(address && address.country) || placeHolder('Country')}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
      <BankDetailsModal
        modal={modal}
        toggleModal={toggleModal}
        bankDetails={bankDetails}
        updateProfile={updateProfile}
        setProfile={setProfile}
        setSession={setSession}
        setUnexpectedError={setUnexpectedError}
      />
    </Fragment>
  );
};

export default BankDetails;
